import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dismiss(event) {
    // Prevent event bubbling to avoid unwanted dismissals
    event.stopPropagation()
    
    // Clear the turbo frame content
    this.element.innerHTML = ""
  }

  visit(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.turboFrameUrl
    const frame = document.getElementById(event.currentTarget.dataset.turboFrame)
    
    if (frame && url) {
      frame.src = url
    }
  }

  // Prevent dismissal when clicking inside the modal content
  prevent(event) {
    event.stopPropagation()
  }
} 